import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/NutricionistaBrasileiraAustralia";
import { pageHead, faqJsonLd, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/nutricionista-brasileira-na-australia")({
  head: () =>
    pageHead({
      title: "Nutricionista em português na Austrália: como funciona | Clara Camille",
      description:
        "Atendimento em português para brasileiros na Austrália. Acompanhamento personalizado para emagrecer com constância. Consulta inicial gratuita.",
      path: "/nutricionista-brasileira-na-australia",
      ogDescription:
        "Atendimento em português para brasileiros na Austrália. Plano alimentar personalizado e consulta inicial gratuita.",
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Nutricionista brasileira na Austrália", path: "/nutricionista-brasileira-na-australia" },
        ]),
        faqJsonLd(faqItems),
      ],
    }),
  component: Page,
});
